// src/lib/mindGarden/wordCategories.ts
// MindGarden（庭）およびTrajectoryMap将来改良用の8カテゴリ分類。
// 通し表（Dropbox/Claude Projects/MIND_GARDEN_WORD_CLASSIFICATION_DRAFT.md）から転記。
// 2026-07-20作成。CTO一次分類案・Kazutoレビュー済み（v3）。
//
// カテゴリはロジカル版54語＋他5デッキ（standard/storytelling/emotion/life/free）の
// 新出語157語＝計211語を対象に、全語をスクリプトで機械的に突き合わせ検証済み
// （未分類0件・重複定義0件）。同じ語が複数デッキに出現する場合も分類は1つに統一。
//
// 修正・追加する場合は、このファイルと通し表（MIND_GARDEN_WORD_CLASSIFICATION_DRAFT.md）の
// 両方を更新すること。

export const WORD_CATEGORIES = [
  "逆接",
  "順接・因果",
  "確信・意志",
  "揺らぎ・余白",
  "時間伸縮",
  "意外性",
  "場面・情景",
  "感嘆",
] as const;

export type WordCategory = (typeof WORD_CATEGORIES)[number];

export const WORD_CATEGORY_MAP: Record<string, WordCategory> = {
  // 逆接（16語）
  "いっぽう": "逆接", "けれども": "逆接", "さもなければ": "逆接", "しかし": "逆接",
  "しかしなぜ": "逆接", "そのくせ": "逆接", "それでも": "逆接", "それにしても": "逆接",
  "でも": "逆接", "とはいえ": "逆接", "にもかかわらず": "逆接", "むしろ": "逆接",
  "一方": "逆接", "一方で": "逆接", "厳密には": "逆接", "対照的に": "逆接",

  // 順接・因果（28語）
  "いいかえると": "順接・因果", "いってみれば": "順接・因果", "こうして": "順接・因果",
  "しかも": "順接・因果", "したがって": "順接・因果", "すると": "順接・因果",
  "そういうわけで": "順接・因果", "そういう意味で": "順接・因果", "そして": "順接・因果",
  "それから": "順接・因果", "それに": "順接・因果", "だから": "順接・因果",
  "だからこそ": "順接・因果", "だからもし": "順接・因果", "たとえば": "順接・因果",
  "つまり": "順接・因果", "では": "順接・因果", "というのも": "順接・因果",
  "ところで": "順接・因果", "なぜなら": "順接・因果", "なにせ": "順接・因果",
  "また": "順接・因果", "ようするに": "順接・因果", "具体的には": "順接・因果",
  "言い換えると": "順接・因果", "詳しくは": "順接・因果", "同様に": "順接・因果",
  "要するに": "順接・因果",

  // 確信・意志（28語）
  "いっそ": "確信・意志", "きっと": "確信・意志", "さすがに": "確信・意志",
  "じつは": "確信・意志", "せっかく": "確信・意志", "せっかくだから": "確信・意志",
  "どうしても": "確信・意志", "とにかく": "確信・意志", "はっきり言って": "確信・意志",
  "まちがいなく": "確信・意志", "もちろん": "確信・意志", "やっぱり": "確信・意志",
  "一応": "確信・意志", "一般的には": "確信・意志", "基本的に": "確信・意志",
  "現実的には": "確信・意志", "言うまでもなく": "確信・意志", "個人的には": "確信・意志",
  "思いきって": "確信・意志", "事実": "確信・意志", "事実上": "確信・意志",
  "実際": "確信・意志", "正確には": "確信・意志", "正直なところ": "確信・意志",
  "通常": "確信・意志", "特に": "確信・意志", "本質的に": "確信・意志",
  "本当は": "確信・意志",

  // 揺らぎ・余白（39語）
  "あまり": "揺らぎ・余白", "あまりに": "揺らぎ・余白", "あるいは": "揺らぎ・余白",
  "あわよくば": "揺らぎ・余白", "おそらく": "揺らぎ・余白", "かなり": "揺らぎ・余白",
  "ここだけの話": "揺らぎ・余白", "ずいぶん": "揺らぎ・余白", "せいぜい": "揺らぎ・余白",
  "せめて": "揺らぎ・余白", "たぶん": "揺らぎ・余白", "たまには": "揺らぎ・余白",
  "だれか": "揺らぎ・余白", "ちょっと": "揺らぎ・余白", "できれば": "揺らぎ・余白",
  "どうか": "揺らぎ・余白", "どうして": "揺らぎ・余白", "どうしよう": "揺らぎ・余白",
  "どうせ": "揺らぎ・余白", "どうやら": "揺らぎ・余白", "なかなか": "揺らぎ・余白",
  "なるべく": "揺らぎ・余白", "なんだか": "揺らぎ・余白", "なんとなく": "揺らぎ・余白",
  "ひそかに": "揺らぎ・余白", "ひとつだけ": "揺らぎ・余白", "びみょうに": "揺らぎ・余白",
  "ひょっとすると": "揺らぎ・余白", "または": "揺らぎ・余白", "まるで": "揺らぎ・余白",
  "もし": "揺らぎ・余白", "もしかすると": "揺らぎ・余白", "もしくは": "揺らぎ・余白",
  "もっと": "揺らぎ・余白", "わりと": "揺らぎ・余白", "一見": "揺らぎ・余白",
  "少し": "揺らぎ・余白", "少しでも": "揺らぎ・余白", "少なくとも": "揺らぎ・余白",

  // 時間伸縮（52語）
  "100ねんたって": "時間伸縮", "１０年後": "時間伸縮", "１０年前": "時間伸縮",
  "２０年後": "時間伸縮", "２０年前": "時間伸縮", "５年後": "時間伸縮", "５年前": "時間伸縮",
  "いつか": "時間伸縮", "いつでも": "時間伸縮", "いつのまにか": "時間伸縮",
  "いつの日か": "時間伸縮", "いつも": "時間伸縮", "いつもは": "時間伸縮",
  "いま": "時間伸縮", "いまでも": "時間伸縮", "これから": "時間伸縮", "さて": "時間伸縮",
  "しばらくして": "時間伸縮", "ずっと": "時間伸縮", "そのとき": "時間伸縮",
  "そもそも": "時間伸縮", "そろそろ": "時間伸縮", "だんだん": "時間伸縮",
  "ついに": "時間伸縮", "ときどき": "時間伸縮", "どんどん": "時間伸縮",
  "はじめて": "時間伸縮", "ふり返ると": "時間伸縮", "まいにち": "時間伸縮",
  "まだ": "時間伸縮", "もう": "時間伸縮", "もう一度": "時間伸縮", "もともと": "時間伸縮",
  "やがて": "時間伸縮", "一度だけ": "時間伸縮", "何度も": "時間伸縮", "去年": "時間伸縮",
  "近いうち": "時間伸縮", "結局": "時間伸縮", "現在": "時間伸縮", "今のところ": "時間伸縮",
  "今度": "時間伸縮", "今日": "時間伸縮", "最近": "時間伸縮", "昨日": "時間伸縮",
  "思えば": "時間伸縮", "人生最後の日": "時間伸縮", "長い目で見れば": "時間伸縮",
  "同時に": "時間伸縮", "明日": "時間伸縮", "来年": "時間伸縮", "歴史的には": "時間伸縮",

  // 意外性（26語）
  "ありがたいことに": "意外性", "うっかり": "意外性", "うれしいことに": "意外性",
  "おもしろいことに": "意外性", "そういえば": "意外性", "それはさておき": "意外性",
  "ちなみに": "意外性", "つい": "意外性", "ところが": "意外性", "とつぜん": "意外性",
  "なぜか": "意外性", "ふしぎなことに": "意外性", "まさか": "意外性",
  "よりによって": "意外性", "案外": "意外性", "楽しみなことに": "意外性",
  "偶然にも": "意外性", "幸運にも": "意外性", "残念ながら": "意外性",
  "思いがけず": "意外性", "思わず": "意外性", "恥ずかしながら": "意外性",
  "悲しいことに": "意外性", "不運にも": "意外性", "不思議なことに": "意外性",
  "腹立たしいことに": "意外性",

  // 場面・情景（12語）
  "あちこちで": "場面・情景", "あるひ": "場面・情景", "せかいじゅうに": "場面・情景",
  "そこで": "場面・情景", "そこには": "場面・情景", "そこへ": "場面・情景",
  "そのころ": "場面・情景", "そらには": "場面・情景", "とおくから": "場面・情景",
  "どこかで": "場面・情景", "どこまでも": "場面・情景", "むかし": "場面・情景",

  // 感嘆（10語）
  "あ": "感嘆", "ああ": "感嘆", "あああああ": "感嘆", "いったい": "感嘆",
  "おや！": "感嘆", "さあ": "感嘆", "しーっ！": "感嘆", "そうだ！": "感嘆",
  "ほら": "感嘆", "まあ": "感嘆",
};

/** 語からカテゴリを引く。未登録語（お題名の直接引用など）はnull */
export function getWordCategory(word: string): WordCategory | null {
  return WORD_CATEGORY_MAP[word] ?? null;
}
